import { useEffect, useMemo } from 'react'
import { useFormikContext } from 'formik'
import { useAppSelector } from '@user/store/hooks'
import {
  isTechValid,
  selectAllTechs,
  isTechInRegion,
  techDisplayName,
  isTechInBranch,
} from '@user/store/techs'
import type { FiltersFormModel, HideableOption } from '../formConfig'

export function useTechs(branchId: number) {
  const {
    setFieldValue,
    values: { techId, techRegionId },
  } = useFormikContext<FiltersFormModel>()

  const allTechs = useAppSelector(selectAllTechs)

  const validTechs = useMemo(
    () =>
      allTechs.filter(
        (tech) => isTechValid(tech) && isTechInBranch(tech, branchId),
      ),
    [allTechs, branchId],
  )

  useEffect(() => {
    if (techId !== '') {
      const selectedTech = validTechs.find((x) => x.id === techId)

      if (selectedTech && !isTechInRegion(selectedTech, techRegionId)) {
        setFieldValue('techId', '')
      }
    }
  }, [validTechs, setFieldValue, techId, techRegionId])

  const techOptions = useMemo(
    () =>
      validTechs.map<HideableOption>((t) => ({
        id: t.techId ?? '',
        label: techDisplayName(t),
        hidden: !isTechInRegion(t, techRegionId),
      })),
    [validTechs, techRegionId],
  )

  return techOptions
}
